import { FinancingFlowApi } from './financing-flow.types';

export default {
  BATTERY_OPTIONS: [
    { name: 'Sim', value: true },
    { name: 'Não', value: false },
  ],
  DEFAULT_PAGE_SIZE: 15,
  getStatusColorClass(step: FinancingFlowApi.Financing['status']) {
    const map: Record<FinancingFlowApi.Financing['status'], string> = {
      approved: 'green',
      canceled: 'red',
      expired: 'black',
      in_progress: 'blue',
      reproved: 'red',
      to_review: 'yellow',
      under_analysis: 'orange',
      waiting_customer: 'purple',
    };

    return map[step] || 'default';
  },

  /**
   * Converts a financing status label to a human-readable format.
   */
  getStatusLabel(label: FinancingFlowApi.Financing['status']) {
    return this.statusMap[label] || label;
  },
  getStepColorClass(step: FinancingFlowApi.Financing['step']) {
    const map: Record<FinancingFlowApi.Financing['step'], string> = {
      biometry_and_contract: 'purple',
      customer_data: 'indigo',
      equipment: 'yello',
      installation: 'lime',
      payment_model: 'cyan',
      simulation: 'green',
    };

    return map[step] || 'blue';
  },
  /**
   * Converts a financing step label to a human-readable format.
   */
  getStepLabel(label: FinancingFlowApi.Financing['step']) {
    return this.stepMap[label] || label;
  },

  pageSizeMap: {
    5: '5',
    10: '10',
    15: '15',
    20: '20',
    25: '25',
    30: '30',
    50: '50',
    100: '100',
  },

  PERSON_TYPE_OPTIONS: [
    { name: 'PF - Pessoa física', value: 'PF' },
    { name: 'PJ - Pessoa jurídica', value: 'PJ' },
  ],

  REASSESSMENT_OPTIONS: [
    { name: 'Sim', value: true },
    { name: 'Não', value: false },
  ],

  STATUS_OPTIONS: [
    { name: 'Cancelado', value: 'canceled' },
    { name: 'Expirado', value: 'expired' },
    { name: 'Reprovado', value: 'reproved' },
    { name: 'Aprovado', value: 'approved' },
    { name: 'Em andamento', value: 'in_progress' },
    { name: 'Revisar', value: 'to_review' },
    { name: 'Em análise', value: 'under_analysis' },
    { name: 'Aguardando cliente', value: 'waiting_customer' },
  ],

  statusMap: {
    approved: 'Aprovado',
    canceled: 'Cancelado',
    expired: 'Expirado',
    in_progress: 'Em andamento',
    reproved: 'Reprovado',
    to_review: 'Revisar',
    under_analysis: 'Em análise',
    waiting_customer: 'Aguardando cliente',
  } as Record<FinancingFlowApi.Financing['status'], string>,

  STEP_OPTIONS: [
    { name: 'Simulação', value: 'simulation' },
    { name: 'Dados do cliente', value: 'customer_data' },
    { name: 'Equipamentos', value: 'equipment' },
    { name: 'Biometria e contrato', value: 'biometry_and_contract' },
    { name: 'Modelo de recebimento', value: 'payment_model' },
    { name: 'Instalação', value: 'installation' },
  ],

  stepMap: {
    biometry_and_contract: 'Biometria e contrato',
    customer_data: 'Dados do cliente',
    equipment: 'Equipamento',
    installation: 'Instalação',
    payment_model: 'Modelo de Recebimento',
    simulation: 'Simulação',
  } as Record<FinancingFlowApi.Financing['step'], string>,
};
